/**
 * Google Analytics utility for SmartGTD WebApp
 */

// Track page views
export const trackPageView = (pageName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }
};

// Track navigation events
export const trackNavigation = (destination) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'navigation', {
      event_category: 'webapp',
      event_label: destination,
      value: 1
    });
  }
};

// Track user actions
export const trackAction = (action, category = 'webapp', label = null, value = null) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const eventData = {
      event_category: category,
      event_label: label
    };
    
    if (value !== null) {
      eventData.value = value;
    }
    
    window.gtag('event', action, eventData);
  }
};

// Track chat interactions
export const trackChatMessage = (messageLength) => {
  trackAction('chat_message_sent', 'chat', 'message_length', messageLength);
};

// Track feature usage
export const trackFeatureUsage = (feature) => {
  trackAction('feature_used', 'features', feature);
};